import { Component, h, Element, Prop, State } from '@stencil/core';

@Component({
  tag: 'qumra-animation',
  styleUrl: 'qumra-animation.css',
  shadow: true,
})
export class QumraAnimation {
  @Element() el!: HTMLElement;
  @Prop() animation: string = 'fade'; 
  @Prop() duration: number = 600; 
  @Prop() always: boolean = false; 
  @State() isVisible: boolean = false;
  @State() shouldAnimate: boolean = false;
  @State() firstTime: boolean = true;

  observer!: IntersectionObserver;

  componentDidLoad() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isVisible = true;
            if (this.firstTime) {
              this.shouldAnimate = true;
              this.firstTime = false;
            }
          } else if (this.always) {
            setTimeout(() => {
              this.isVisible = false;
            }, this.duration);
          }
        });
      },
      { threshold: 0.2 }
    );

    this.observer.observe(this.el);
  }

  render() {
    const animationClasses = this.animation.split(' ').reduce((acc, anim) => {
      acc[anim] = true;
      return acc;
    }, {});

    return (
      <div class={{ 'reveal': true, ...animationClasses, 'visible': this.isVisible, 'animate': this.shouldAnimate }} style={{ transitionDuration: `${this.duration}ms` }}>
        <slot></slot>
      </div>
    );
  }
}
